import React, { ReactElement } from 'react';
import styled from '@emotion/styled';
import { Link } from 'react-router-dom';
import Avatar from './Avatar';
import Button from './buttons/Button';
import { spacing, type, getBorders, getTextColor } from '../style';
import colors from '../theme/colors';
import { isDarkMode } from '../utils/helpers';
import breakpoints from '../theme/material/breakpoints';

const StyledContainer = styled('div')(() => ({
  ...getTextColor().DARKER,
  display: 'flex',
  alignItems: 'center',
  ...spacing.PADDING_MD,
  borderBottom: getBorders().DEFAULT,
  [breakpoints.down(639.05)]: {
    ...spacing.PADDING_SM,
  },
}));

const UserLink = styled(Link)({
  flexGrow: 1,
  display: 'flex',
  alignItems: 'center',
});

const Title = styled('p')(() => ({
  fontSize: '15px',
  fontWeight: 400,
  letterSpacing: '-0.3px',
  color: isDarkMode() ? '#CFCFCF' : colors.light.gray.light,
  margin: '0 0 8px 0',
}));

const Meta = styled('div')(() => ({
  ...type.SM,
  fontWeight: 400,
  letterSpacing: '-0.26px',
  color: isDarkMode() ? 'rgb(175, 176, 177)' : '#8F8F8F',
}));

const ButtonContainer = styled('div')({
  flex: '0 0 auto',
});

interface BlockedUserItemProps {
  hashId: string;
  avatar: any;
  username: string;
  userDetails: any;
  onUnblock: any;
  buttonTitle: string;
}

const BlockedUserItem = ({
  hashId,
  avatar,
  username,
  userDetails,
  onUnblock,
  buttonTitle,
}: BlockedUserItemProps): ReactElement => {
  return (
    <StyledContainer>
      <UserLink to={`/profile/${hashId}`}>
        <Avatar
          src={avatar}
          width={60}
          customStyle={{
            ...spacing.MARGIN_RIGHT_SM,
          }}
        />
        <div>
          <Title>{username}</Title>
          <Meta>{userDetails}</Meta>
        </div>
      </UserLink>
      <ButtonContainer>
        <Button
          buttonType="primaryRed"
          onClick={() => onUnblock(username, hashId)}
          isDefault={true}
          customStyle={{
            fontSize: '13px !important',
            lineHeight: '16px !important',
            fontWeight: '700 !important',
          }}
        >
          {buttonTitle}
        </Button>
      </ButtonContainer>
    </StyledContainer>
  );
};

export default BlockedUserItem;
